module.exports = __webpack_public_path__ + "img/mile5-m@2.93e30149.webp";